import Header from "components/Headers/Header";
import {
  Container,
  Spinner,
  Button,
  Card,
  TabContent,
  TabPane,
  NavItem,
  Nav,
  NavLink,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizers } from "store/actions/organizerAction";
import TableComponent from "components/TableComponent";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import { updateOrganizerStatus } from "store/actions/organizerAction";

const columns = [
  "Photo Id",
  "Name",
  "Email",
  "Number",
  "Organization",
  "Tournament Details",
  "Website",
  "Status",
  "Requested At",
];

const keyMap = {
  "Photo Id": "photoId",
  Name: "name",
  Email: "email",
  Number: "number",
  Organization: "organization",
  "Tournament Details": "tournamentDetails",
  Website: "website",
  Status: "status",
  "Requested At": "createdAt",
};

const Contest = () => {
  const dispatch = useDispatch();
  const { organizers, lastVisible, hasMore } = useSelector(
    (state) => state.organizer
  );
  const Organizers = organizers?.map((organizer) => ({
    ...organizer,
    createdAt: new Date(organizer.createdAt.seconds * 1000).toLocaleDateString(
      "en-US"
    ),
    photoId: organizer?.photoId ? (
      <img
        src={organizer?.photoId}
        alt="photo-id"
        style={{
          width: "100px",
          height: "65px",
          objectFit: "contain",
          borderRadius: "4px",
        }}
      />
    ) : (
      "N/A"
    ),
  }));

  const [activeTab, setActiveTab] = useState("Organizer Requests");
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const [actionType, setActionType] = useState("");
  const [activeId, setActiveId] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const confirmationModalToggler = () => {
    if (confirmationModal) {
      setActionType("");
      setActiveId(null);
    }
    setConfirmationModal(!confirmationModal);
  };

  const intiateAction = (type, id) => {
    setActionType(type);
    setActiveId(id);
    confirmationModalToggler();
  };

  const handleUpdateStatus = () => {
    setIsUpdating(true);
    dispatch(
      updateOrganizerStatus({
        id: activeId,
        status: actionType === "approve" ? "accepted" : "rejected",
      })
    )
      .then(() => confirmationModalToggler())
      .finally(() => setIsUpdating(false));
  };

  const renderActions = (organizer) => (
    <>
      <Button
        color="primary"
        size="sm"
        onClick={() => intiateAction("approve", organizer?.uid)}
      >
        Accept
      </Button>
      <Button
        color="danger"
        size="sm"
        onClick={() => intiateAction("reject", organizer?.uid)}
      >
        Reject
      </Button>
    </>
  );

  const handleLoadMore = () => {
    setIsLoading(true);
    dispatch(
      fetchOrganizers({
        status: activeTab === "Organizer Requests" ? "pending" : "accepted",
        lastVisible,
      })
    ).finally(() => setIsLoading(false));
  };

  useEffect(() => {
    setIsFetching(true);
    dispatch(
      fetchOrganizers({
        status: activeTab === "Organizer Requests" ? "pending" : "accepted",
      })
    ).finally(() => setIsFetching(false));
  }, [activeTab]);

  return (
    <>
      <Header />
      <Container fluid className="my-5">
        <Card className="pb-2">
          <Nav
            tabs
            className="d-flex justify-content-start text-dark athlete_earning-nav"
          >
            <NavItem>
              <NavLink
                className={
                  activeTab === "Organizer Requests"
                    ? "active active-tab py-2 bg-primary "
                    : "text-dark cursor-pointer py-2 "
                }
                onClick={() => {
                  toggleTab("Organizer Requests");
                }}
              >
                <h2
                  className={
                    activeTab === "Organizer Requests" ? "text-white" : ""
                  }
                >
                  Organizer Requests
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={
                  activeTab === "Active Organizers"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("Active Organizers");
                }}
              >
                <h2
                  className={
                    activeTab === "Active Organizers" ? "text-white" : ""
                  }
                >
                  Active Organizers
                </h2>
              </NavLink>
            </NavItem>
          </Nav>

          <>
            <TabContent
              activeTab={activeTab}
              className="p-3 athlete-earning-content"
            >
              <TabPane tabId="Organizer Requests">
                {isFetching ? (
                  <div className="py-5 d-flex justify-content-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <TableComponent
                    columns={columns}
                    keyMap={keyMap}
                    data={Organizers}
                    renderActions={renderActions}
                  />
                )}
              </TabPane>
              <TabPane tabId="Active Organizers">
                {isFetching ? (
                  <div className="py-5 d-flex justify-content-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <TableComponent
                    columns={columns}
                    keyMap={keyMap}
                    data={Organizers}
                  />
                )}
              </TabPane>
            </TabContent>
            {hasMore && (
              <div className="d-flex justify-content-center py-4">
                <Button
                  color="primary"
                  onClick={handleLoadMore}
                  disabled={isFetching || isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? <Spinner size="sm" /> : "Load More"}
                </Button>
              </div>
            )}
          </>
        </Card>
      </Container>
      <ConfirmationModal
        isOpen={confirmationModal}
        toggle={confirmationModalToggler}
        onConfirm={handleUpdateStatus}
        isLoading={isUpdating}
        title={`${actionType} Organzier`}
        message={`Are you sure you want to ${actionType} this organizer?`}
      />
    </>
  );
};

export default Contest;
